<template>
  <layout-form>
    <input-last-name />
    <input-first-name />
    <input-email />
    <input-password />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib/Layout/Form'
import InputLastName from './InputLastName'
import InputFirstName from './InputFirstName'
import InputEmail from './InputEmail'
import InputPassword from './InputPassword'

export default {
  components: {
    LayoutForm,
    InputLastName,
    InputFirstName,
    InputEmail,
    InputPassword
  }
}
</script>
